module.exports = __webpack_public_path__ + "img/summit-mascot.79f58a9f.png";